import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'

export async function createPipComposition(
  refs: SessionRefs,
  screenStream: MediaStream
): Promise<MediaStream | null> {
  try {
    if (!refs.pipCanvasRef.current) {
      const canvas = document.createElement('canvas')
      canvas.width = 1920
      canvas.height = 1080
      refs.pipCanvasRef.current = canvas
    }

    const ctx = refs.pipCanvasRef.current.getContext('2d')
    if (!ctx || !refs.mediaStreamRef.current) return null

    const screenVideo = document.createElement('video')
    screenVideo.srcObject = screenStream
    screenVideo.muted = true
    await screenVideo.play()

    const cameraVideo = document.createElement('video')
    cameraVideo.srcObject = refs.mediaStreamRef.current
    cameraVideo.muted = true
    await cameraVideo.play()

    const drawPiP = () => {
      if (!ctx || !refs.pipCanvasRef.current) return

      ctx.drawImage(screenVideo, 0, 0, 1920, 1080)
      const pipWidth = 320
      const pipHeight = 180
      const padding = 20
      const x = 1920 - pipWidth - padding
      const y = 1080 - pipHeight - padding

      ctx.save()
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 10
      ctx.fillStyle = '#000'
      ctx.fillRect(x - 2, y - 2, pipWidth + 4, pipHeight + 4)
      ctx.drawImage(cameraVideo, x, y, pipWidth, pipHeight)
      ctx.restore()

      refs.pipAnimationRef.current = requestAnimationFrame(drawPiP)
    }

    drawPiP()
    const compositeStream = refs.pipCanvasRef.current.captureStream(30)
    refs.pipCompositeStreamRef.current = compositeStream
    logger.info('PiP composition started successfully')
    return compositeStream
  } catch (err) {
    logger.error('Failed to start PiP composition', { error: String(err) })
    return null
  }
}
